/* 776BC Test Crew landing sections (tc-*) — shared behaviour.
   Loaded with `defer` from each tc- section; guarded so it only
   initialises once however many sections include it. No jQuery. */
(function () {
  'use strict';
  if (window.tc776Init) return;
  window.tc776Init = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Days left until intake close ----------------------------
     Elements carry data-tc-deadline="YYYY-MM-DD" (empty = last day
     of the current month, matching the design's fallback). Child
     hooks: [data-tc-days] gets the number, [data-tc-days-word]
     gets Day/Days (data-tc-case="lower" for the bar). */
  function daysLeft(closeDate) {
    var end;
    if (closeDate && /^\d{4}-\d{2}-\d{2}$/.test(closeDate)) {
      var p = closeDate.split('-');
      end = new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59);
    } else {
      var now = new Date();
      end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
    }
    return Math.max(0, Math.ceil((end - new Date()) / 86400000));
  }

  function renderDeadlines() {
    var els = document.querySelectorAll('[data-tc-deadline]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var d = daysLeft(el.getAttribute('data-tc-deadline'));
      var nums = el.querySelectorAll('[data-tc-days]');
      for (var j = 0; j < nums.length; j++) nums[j].textContent = d;
      var words = el.querySelectorAll('[data-tc-days-word]');
      for (var k = 0; k < words.length; k++) {
        var w = d === 1 ? 'Day' : 'Days';
        words[k].textContent = words[k].getAttribute('data-tc-case') === 'lower' ? w.toLowerCase() : w;
      }
    }
  }
  renderDeadlines();
  setInterval(renderDeadlines, 60000);

  /* ---- Sticky apply bar -----------------------------------------
     Mobile: always visible (CSS). Desktop: revealed after scrolling
     past ~72vh, matching the design's scroll logic. */
  var bar = document.querySelector('[data-tc-bar]');
  if (bar) {
    var desktop = window.matchMedia('(min-width: 768px)');
    var onScroll = function () {
      if (!desktop.matches) return;
      var show = window.scrollY > Math.max(240, window.innerHeight * 0.72);
      bar.classList.toggle('is-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---- Hero video: respect prefers-reduced-motion --------------- */
  function applyMotionPreference() {
    var vids = document.querySelectorAll('[data-tc-hero-video]');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (reducedMotion.matches) {
        v.removeAttribute('autoplay');
        v.pause();
        try { v.currentTime = 0; } catch (e) { /* not loaded yet */ }
      } else if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
  }
  applyMotionPreference();
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', applyMotionPreference);

  /* ---- Steps accordion ------------------------------------------ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-tc-acc-toggle]');
    if (!toggle) return;
    var item = toggle.closest('[data-tc-acc-item]');
    var list = toggle.closest('[data-tc-acc]');
    if (!item || !list) return;
    var wasOpen = item.classList.contains('is-open');
    var items = list.querySelectorAll('[data-tc-acc-item]');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove('is-open');
      var b = items[i].querySelector('[data-tc-acc-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    if (!wasOpen) {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---- Carousel arrows (UGC) ------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tc-carousel-prev], [data-tc-carousel-next]');
    if (!btn) return;
    var section = btn.closest('[data-tc-carousel-scope]');
    var row = section && section.querySelector('[data-tc-carousel]');
    if (!row) return;
    var dir = btn.hasAttribute('data-tc-carousel-prev') ? -1 : 1;
    var amt = Math.min(row.clientWidth * 0.85, 700);
    row.scrollBy({ left: dir * amt, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });

  /* ---- Play button swaps poster for video (split media, editorial) --
     data-tc-video-src: hosted mp4, played in a <video>.
     data-tc-embed-src: YouTube/Vimeo embed URL, loaded in an <iframe>.
     data-tc-video-class: class for the element that replaces the button
     (defaults to the split-media class). */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-tc-play]');
    if (!play) return;
    var cls = play.getAttribute('data-tc-video-class') || 'tc-split__video';
    var label = play.getAttribute('aria-label') || '';
    var src = play.getAttribute('data-tc-video-src');
    var embed = play.getAttribute('data-tc-embed-src');
    if (src) {
      var video = document.createElement('video');
      video.className = cls;
      video.src = src;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('aria-label', label);
      play.replaceWith(video);
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } else if (embed) {
      var frame = document.createElement('iframe');
      frame.className = cls;
      frame.src = embed;
      frame.title = label;
      frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('frameborder', '0');
      play.replaceWith(frame);
    }
  });

  /* ---- HubSpot form: load v2 embed script when section nears ---- */
  var hs = document.querySelector('[data-tc-hubspot]');
  if (hs && hs.getAttribute('data-portal-id') && hs.getAttribute('data-form-id')) {
    var createForm = function () {
      if (!window.hbspt || !window.hbspt.forms) return;
      window.hbspt.forms.create({
        region: hs.getAttribute('data-region') || 'na1',
        portalId: hs.getAttribute('data-portal-id'),
        formId: hs.getAttribute('data-form-id'),
        target: '[data-tc-hubspot]'
      });
    };
    var loadHubspot = function () {
      if (window.tc776HubspotLoading) return;
      window.tc776HubspotLoading = true;
      if (window.hbspt && window.hbspt.forms) { createForm(); return; }
      var s = document.createElement('script');
      s.src = 'https://js.hsforms.net/forms/embed/v2.js';
      s.defer = true;
      s.onload = createForm;
      document.body.appendChild(s);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            loadHubspot();
            return;
          }
        }
      }, { rootMargin: '600px 0px' });
      io.observe(hs);
    } else {
      loadHubspot();
    }
  }

  /* ---- Athlete editorial: story menu follows the reader --------- */
  var edNavs = document.querySelectorAll('[data-tc-ed-nav]');
  var edMobile = window.matchMedia('(max-width: 1099px)');
  for (var n = 0; n < edNavs.length; n++) {
    (function (nav) {
      var slot = nav.closest('[data-tc-ed-nav-slot]') || nav.parentNode;
      var section = nav.closest('.tc-editorial');
      var list = nav.querySelector('.tc-ed__nav-list');
      var links = nav.querySelectorAll('[data-tc-ed-target]');
      var stories = [];
      for (var i = 0; i < links.length; i++) {
        var el = document.getElementById(links[i].getAttribute('data-tc-ed-target'));
        if (el) stories.push({ el: el, link: links[i] });
      }
      if (!stories.length) return;
      var behavior = function () { return reducedMotion.matches ? 'auto' : 'smooth'; };
      var revealLink = function (link) {
        if (list && list.scrollWidth > list.clientWidth + 1) {
          list.scrollTo({ left: link.offsetLeft - (list.clientWidth - link.offsetWidth) / 2, behavior: behavior() });
        } else if (nav.scrollHeight > nav.clientHeight + 1) {
          nav.scrollTo({ top: link.offsetTop - (nav.clientHeight - link.offsetHeight) / 2, behavior: behavior() });
        }
      };
      var current = null;
      var setCurrent = function (item) {
        if (item === current) return;
        if (current) current.link.removeAttribute('aria-current');
        item.link.setAttribute('aria-current', 'true');
        current = item;
        revealLink(item.link);
      };
      /* Mobile: dock the menu to the bottom of the screen once its
         slot has scrolled off the top, while the stories are still on screen. */
      var docked = false;
      var setDocked = function (on) {
        if (on === docked) return;
        docked = on;
        if (on) {
          slot.style.height = nav.offsetHeight + 'px';
          nav.classList.add('tc-ed__nav--docked');
          if (current) revealLink(current.link);
        } else {
          nav.classList.remove('tc-ed__nav--docked');
          slot.style.height = '';
        }
      };
      var update = function () {
        var line = window.innerHeight * 0.4;
        var best = stories[0];
        for (var i = 0; i < stories.length; i++) {
          if (stories[i].el.getBoundingClientRect().top <= line) best = stories[i];
        }
        setCurrent(best);
        if (edMobile.matches && section) {
          var slotRect = slot.getBoundingClientRect();
          var secRect = section.getBoundingClientRect();
          setDocked(slotRect.bottom < 0 && secRect.bottom > window.innerHeight * 0.5);
        } else {
          setDocked(false);
        }
      };
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      if (edMobile.addEventListener) edMobile.addEventListener('change', onScroll);
      nav.addEventListener('click', function (e) {
        var link = e.target.closest('[data-tc-ed-target]');
        if (!link) return;
        var target = document.getElementById(link.getAttribute('data-tc-ed-target'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ block: 'start', behavior: behavior() });
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + target.id);
      });
      update();
    })(edNavs[n]);
  }
})();
